import loggingService from './loggingService'

var serviceName = 'componentService'
var isDebug = false

function getComponentNameDebug (vueComponent) {
    if (vueComponent == null) {
        loggingService.log(isDebug, serviceName, 'getComponentNameDebug, vueComponent is null')
        return null
    }

    return vueComponent.$options.name + ' (_uid: ' + vueComponent._uid + ')'
}

export default {
    getComponentNameDebug: getComponentNameDebug
}



// WEBPACK FOOTER //
// ./src/services/util/componentService.js